import React from 'react';
import { CosmeticRepairRequestType } from './CosmeticRepairRequestTypes';
//@ts-ignore
import { getDisplayFormattedDate } from '../../common/dateTimeDisplay/DateTimeDisplay';
import PanelWithButton from '../../common/panelWithButton/PanelWithButton';
import { useTranslation } from 'react-i18next';
import { TranslationHelper } from 'classes/TranslationHelper';

export type CosmeticRequestsInfoProps = {
    cosmeticRequests: CosmeticRepairRequestType[];
    onUpdateCosmeticRequest: (updateRequestId) => void;
};

const CosmeticRequestsInfo = ({
    cosmeticRequests,
    onUpdateCosmeticRequest
}: CosmeticRequestsInfoProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <div className='card-body page-content-body'>
            {cosmeticRequests.map((repairRequest, index) => (
                <PanelWithButton
                    id={`wheel-summary-container-${index.toString()}`}
                    buttonText={t('update')}
                    onButtonClick={() =>
                        onUpdateCosmeticRequest(repairRequest.id)
                    }
                    key={index}>
                    <b>{t('repair_request_number')}: </b>
                    {index + 1}
                    <br />
                    <b>
                        {t('cosmetic_repair_request_section.date_of_incident')}
                    </b>
                    {getDisplayFormattedDate(
                        new Date(
                            JSON.parse(repairRequest.dateOfIncident).value //eslint-disable-line
                        ),
                        false
                    )}
                    <br />
                    <b>{t('panel')}: </b>
                    {repairRequest.selectedPanels
                        .map((m) => TranslationHelper.getTranslatedText(m))
                        .join(' , ')}
                </PanelWithButton>
            ))}
        </div>
    );
};

export default CosmeticRequestsInfo;
